<template>
    <div>
        <hero-section class="hero-section" />
        <submission-progress-bar
            class="mb-5"
            :submission-step="submissionStep"
            :referral="referral"
        />
        <submission-form-step-1
            v-if="submissionStep === 1"
            @update="update"
        />
        <submission-form-step-2
            v-else-if="submissionStep === 2"
            @update="update"
        />
        <submission-form-step-3
            v-else-if="submissionStep === 3"
            @update="update"
            @submit-form="submitForm"
        />
        <p
            v-if="submissionStep === 4"
            class="successful-submission"
        >
            {{ $t('successfulSubmission') }}
        </p>
        <gdpr-info class="gdpr-container" />
    </div>
</template>

<script>
    import submissionService from '@/services/submission-service'
    import SubmissionFormStep1 from '@/components/SubmissionFormStep1'
    import SubmissionFormStep2 from '@/components/SubmissionFormStep2'
    import SubmissionFormStep3 from '@/components/SubmissionFormStep3'
    import GdprInfo from '@/components/GdprInfo'
    import HeroSection from '@/components/HeroSection'
    import SubmissionProgressBar from '@/components/SubmissionProgressBar'
    import jobPositionService from '@/services/job-position-service'

    export default {
        name: 'SubmissionRoute',
        components: {
            SubmissionFormStep1,
            SubmissionFormStep2,
            SubmissionFormStep3,
            GdprInfo,
            SubmissionProgressBar,
            HeroSection
        },
        beforeRouteLeave(to, from, next) {
            if (this.isEditing) {
                if (!window.confirm()) {
                    return
                }
            }
            next()
        },
        data() {
            return{
                submission: {},
                isEditing: false,
                submissionStep: 1,
                referral: null
            }
        },
        created() {
            const code = this.$route.query.referral
            jobPositionService.fetchJobPositionByCode(code).then(referral => {
                if (referral) {
                    this.referral = referral.code
                } else {
                    this.referral = 'GEN1'
                }
            })
        },
        beforeMount() {
            window.addEventListener('beforeunload', this.preventNav)
            this.$once("hook:beforeDestroy", () => {
                window.removeEventListener('beforeunload', this.preventNav)
            })
        },
        methods: {
            async update(submissionUpdate){
                this.submission = { ...this.submission, ...submissionUpdate }
                if(this.submissionStep <= 4){
                    let code = this.referral

                    if (code !== 'GEN1' && this.submissionStep === 1) {
                        this.submissionStep = 2
                    }
                    this.submissionStep += 1
                }
            },
            submitForm(){
                this.submission.language = localStorage
                    .getItem('lang') === 'el' ? 'GREEK' : 'ENGLISH'

                submissionService.submitForm(this.submission, this.referral)
                    .then(
                        this.isEditing = false
                    )
            },
            preventNav(event) {
                if (!this.isEditing) return
                event.preventDefault()
                event.returnValue = ""
            }
        }
    }
</script>

<style scoped>
.hero-section {
    margin-bottom: 5rem;
}

.gdpr-container {
    margin-top: 3rem;
    margin-bottom: 5rem;
}

.successful-submission {
    text-align: center;
    font-size: 1rem;
    font-weight: 300;
    border-bottom: 1px solid #87c9e6;
    padding-bottom: 2rem;
    width: 90%;
    max-width: 480px;
    margin: 0 auto;
}

@media screen and (min-width: 480px) {
    .gdpr-container {
        margin-top: 5rem;
    }
}

@media screen and (min-width: 768px) {
    .successful-submission {
        font-size: 1.05rem;
        max-width: 750px;
    }
}

@media screen and (min-width: 992px) {
    .successful-submission {
        font-size: 1.1rem;
        max-width: 1170px;
    }

    .gdpr-container {
        margin-bottom: 6rem;
    }
}
</style>